<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

defineProps({
  artifact: { type: Object, default: null },
  loading: { type: Boolean, default: false },
});

const emit = defineEmits(['upload']);
const input = ref(null);
const { t } = useI18n();
const select = event => emit('upload', event.target.files?.[0]);
</script>

<template>
  <div
    data-testid="post-sale-deed-feedback-proof"
    class="grid gap-3 rounded-lais-sm border border-dashed border-lais-border bg-lais-bg-soft p-4"
  >
    <p class="mb-5 text-base leading-[22px] text-lais-text">
      {{ t('POST_SALE.DEED_FEEDBACK.PROOF.TITLE') }}
      <span class="text-lais-text-muted">
        {{ t('POST_SALE.DEED_FEEDBACK.PROOF.HELP') }}
      </span>
      {{ t('POST_SALE.DEED_FEEDBACK.REQUIRED_SUFFIX') }}
    </p>
    <input
      ref="input"
      class="hidden"
      type="file"
      accept="application/pdf,.pdf,image/jpeg,.jpg,.jpeg,image/png,.png"
      @change="select"
    />
    <LaisPrimaryButton
      :is-loading="loading"
      icon="i-lucide-upload"
      @click="input?.click()"
    >
      {{ t('POST_SALE.DEED_FEEDBACK.PROOF.CHOOSE') }}
    </LaisPrimaryButton>
    <p v-if="artifact" class="text-sm font-medium text-emerald-700">
      {{ artifact.filename }}
    </p>
  </div>
</template>
